import { Injectable } from '@angular/core';

import { HttpClient, HttpEvent, HttpParams } from '@angular/common/http';
import { Category } from '../../models/category';
import { Multimedia } from 'src/app/modules/shared/models/multimedia';
import { Observable } from 'rxjs';
import { ConfigService } from '@core/services/config.service';
import { PageList } from '@core/models/page-list';
import { BaseApiService } from '@core/http/base.api.service';
import { CategoryPagination } from '@modules/category/models/category-pagination';
import { CategoryFilter } from '@modules/category/models/category-filter';

@Injectable({
  providedIn: 'root'
})
export class CategoryApiService extends BaseApiService {
  constructor(public http: HttpClient, private configService: ConfigService) {
    super(http);
  }

  public get BaseUrl(): string {
    const config = this.configService.getCurrent();
    return `${config.services.experience}/api/category`;
  }

  public fetchCategories({pageOffset = 0, pageSize = 1000 }: CategoryPagination, { isFeatured = true, excludeEmpty = false }: CategoryFilter
  ): Observable<PageList<Category>> {
    const params = new HttpParams().appendAll({pageOffset, pageSize, isFeatured, excludeEmpty})
    return super.getAllWithPagination(`${this.BaseUrl}`, params);
  }

  public getById(id: string): Observable<Category> {
    return super.get(`${this.BaseUrl}`, id);
  }

  public create(create: Partial<Category>): Observable<Category> {
    return super.register(this.BaseUrl, create);
  }

  public edit(id: string, change: Partial<Category>): Observable<Category> {
    return super.update(`${this.BaseUrl}/${id}`, change);
  }

  public remove(id: string): Observable<any> {
    return super.delete(`${this.BaseUrl}/${id}`);
  }

  public uploadMedias(id: string, files: File[], tags: string): Observable<HttpEvent<Multimedia[]>> {
    const params = new HttpParams().append('tags', tags);

    const formData = new FormData();
    for (const file of files) {
      formData.append('files', file);
    }

    return super.uploadMedia(`${this.BaseUrl}/${id}/media`, formData, params);
  }

  public updateMedia(id: string, name: string, defualt: boolean, category?: string): Observable<Multimedia> {
    const media: Partial<Multimedia> = {
      name: name,
      default: defualt,
      category: category ? category : '',
    };

    return super.update<Multimedia>(`${this.BaseUrl}/${id}/media`, media);
  }

  public deleteMedia(id: string, mediaName: string): Observable<any> {
    const params = new HttpParams().append('name', mediaName);

    return super.delete(`${this.BaseUrl}/${id}/media`, { params: params });
  }
}
